import { createAppErrorClass } from '../../app-error/app-error'
import { has, isObject } from 'lodash'
import { BaseOutput } from './base-output.model'
// eslint-disable-next-line @typescript-eslint/naming-convention
export const UnexpectedResponsePayload = createAppErrorClass<{ responseBody: Record<string, unknown> }>(
  'UnexpectedResponsePayload',
)

// eslint-disable-next-line @typescript-eslint/naming-convention
export const WrongCredentials = createAppErrorClass('WrongCredentials')
// eslint-disable-next-line @typescript-eslint/naming-convention
export const DisabledAccount = createAppErrorClass('DisabledAccount')
// eslint-disable-next-line @typescript-eslint/naming-convention
export const BlacklistedAccount = createAppErrorClass('BlacklistedAccount')
// eslint-disable-next-line @typescript-eslint/naming-convention
export const BlacklistedIp = createAppErrorClass('BlacklistedIp')
// eslint-disable-next-line @typescript-eslint/naming-convention
export const OtherLoginError = createAppErrorClass('OtherLoginError')
// eslint-disable-next-line @typescript-eslint/naming-convention
export const NoRedirectUrl = createAppErrorClass('NoRedirectUrl')
// eslint-disable-next-line @typescript-eslint/naming-convention
export const NoClient = createAppErrorClass('NoClient')
// eslint-disable-next-line @typescript-eslint/naming-convention
export const LogoutError = createAppErrorClass('LogoutError')

export type LoginError =
  | typeof WrongCredentials
  | typeof DisabledAccount
  | typeof BlacklistedAccount
  | typeof BlacklistedIp
  | typeof OtherLoginError
  | typeof NoRedirectUrl

export interface GenericValidationErrorPayload {
  errors: { [invalidFieldName: string]: Array<{ code: string; message: string }> }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isGenericValidationErrorPayload = (error: any): error is GenericValidationErrorPayload =>
  isObject(error) && has(error, 'errors')

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ValidationError = createAppErrorClass<GenericValidationErrorPayload>('ValidationError')

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ValidationFieldError = createAppErrorClass<BaseOutput>('ValidationFieldError')
